import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDesignFolderDocument } from './update.generated';

export const useUpdateDesignFolder = (
  options: ApiOptions<typeof UpdateDesignFolderDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateDesignFolderDocument, {
    ...useNotifications(UpdateDesignFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.design_folders.update_success'),
    }),
    ...options,
  });
};
